import { render, staticRenderFns } from "./StocktakingProfitAndLoss.vue?vue&type=template&id=20e199c7&scoped=true&"
import script from "./StocktakingProfitAndLoss.vue?vue&type=script&lang=js&"
export * from "./StocktakingProfitAndLoss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e199c7",
  null
  
)

export default component.exports